//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'

import RequestForkliftTruckField from './RequestForkliftTruckField.vue'
import RequestYandexExecutorField from './RequestYandexExecutorField.vue'
import RequestYandexExecutorJournal from './RequestYandexExecutorJournal.vue'
// import ReportYandexTasks from '../Report/ReportYandexTasks.vue'
import RequestExecutorSelectionWindow from './RequestExecutorSelectionWindow.vue'
import ReportContentSection from '../Report/ReportContent/ReportContentSection.vue'
import { requestExecutorActions } from './RequestExecutorActions.js'
import { requestRedirectionWorkAreas } from './RequestRedirectionWorkAreas'

export default {
  components: {
    RequestYandexExecutorField,
    RequestYandexExecutorJournal,
    // ReportYandexTasks,
    RequestForkliftTruckField,
    RequestExecutorSelectionWindow,
    ReportContentSection
  },
  mixins: [requestExecutorActions, requestRedirectionWorkAreas],
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default () {
        return ''
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    isInitialize: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workAreas: [],
      autoAssigns: [
        { name: 'Не участвует в автоматическом назначении', value: 'false' },
        { name: 'Участвует в автоматическом назначении', value: 'true' }
      ],
      worksCheckVariants: [
        { name: 'Требуется', value: 'true' },
        { name: 'Не требуется', value: 'false' }
      ]
    }
  },
  computed: {
    autoAssignText: {
      get: function () {
        return this.request != null ? String(this.request.autoAssign) : null
      },
      set: function (newValue) {
        if (this.request) {
          if (newValue == 'true') {
            this.request.autoAssign = true
            this.request.proposedExecutorObject = null
            this.request.proposedReinforcementExecutorObject = null
          } else if (newValue == 'false') {
            this.request.autoAssign = false
            this.request.autoAssignStartTime = null
          }
        }
      }
    },
    autoAssignStartTimeStr: {
      get: function () {
        if (this.request && this.request.autoAssignStartTime) {
          return this.formatMillis(this.request.autoAssignStartTime)
        } else {
          return null
        }
      },
      set: function (newValue) {
        if (newValue) {
          this.request.autoAssignStartTime = this.parseMillis(newValue)
        } else {
          this.request.autoAssignStartTime = null
        }
      }
    },
    worksCheckRequiredText: {
      get: function () {
        return this.request != null ? String(this.request.worksCheckRequired) : null
      },
      set: function (newValue) {
        if (this.request) {
          this.request.worksCheckRequired = newValue === 'true'
        }
      }
    },
    requestExecutorPropertiesEditable: function () {
      // || this.taskStatus == 'BS8' TODO
      return this.requestRoles.hasEditAccess && this.requestRoles.roleDispatcherOrHigher && !this.requestRoles.roleExternalDispatcher && //
      (this.taskStatus == 'BS0' || this.taskStatus == 'BS1' || this.taskStatus == 'BS2' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13')
    },
    requestExecutorPropertiesReadonly: function () {
      return !this.requestExecutorPropertiesEditable
    },
    executorChangeAvailable: function () {
      return (this.requestRoles.executorChangeAvailable || this.requestRoles.executorChangeAvailableByContractor) && (this.taskStatus == 'BS0' || this.taskStatus == 'BS1' || this.taskStatus == 'BS2' || this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || this.taskStatus == 'BS8' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13')
    },
    reinforcementExecutorChangeAvailable: function () {
      return this.requestRoles.roleDispatcherOrHigher && (this.taskStatus == 'BS0' || this.taskStatus == 'BS1' || this.taskStatus == 'BS2' || this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || this.taskStatus == 'BS5' || this.taskStatus == 'BS8' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13')
    },
    notExternalDispatcherCreation: function () {
      return !(this.taskStatus == 'BS0' && this.requestRoles.roleExternalDispatcher)
    }
  },
  watch: {
    'request.proposedExecutorObject': {
      handler: function (object, oldObject) {
        if (object == null) {
          if (!this.request.hasAssignedExecutor && oldObject != null) {
            this.request.autoAssign = true
          }
        } else {
          this.request.autoAssign = false
        }
      },
      immediate: true
    },
    'request.proposedReinforcementExecutorObject': {
      handler: function (object) {
        if (object != null && object.executors.length !== 0) {
          this.request.autoAssign = false
        }
      },
      immediate: true
    }
  },
  created: function () {
    this.getRedirectionWorkAreas()
  },
  methods: {
    getRedirectionWorkAreas: async function () {
      this.workAreas = await this.redirectionWorkAreas(this.request.serviceObject)
    },
    formatMillis: function (millis) {
      console.log()
      if (millis) {
        return date.formatDate(millis, 'DD.MM.YYYY HH:mm')
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, 'DD.MM.YYYY HH:mm')
    },
    parseMillis (value) {
      return this.parseDate(value).getTime()
    }
  }
}

